import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getScenarioStats, type LabStatsQueryParams } from '@/services/classLabPlatformService';

export interface ScenarioStatsResponse {
    classData: {
        id: number;
        minPassingScore: number;
        class_name: string;
        customer_name: string;
        organizationId: number;
    };
    stats: {
        total_participants: number;
        pass_count: number;
        total_play_count: number;
        total_play_time: number;
    };
    contentList: Array<{
        content_code: string;
        scenario_name: string;
        mode_value_title?: string;
        play_count: number;
        total_play_time: number;
        participant_count: number;
        completion_rate: number | null;
        avg_score: number | null;
    }>;
    total_count: number;
    total_page: number;
}

export function useScenarioStats(
    classId: number,
    params?: LabStatsQueryParams,
    options?: Omit<UseQueryOptions<ScenarioStatsResponse>, 'queryKey' | 'queryFn'>
) {
    return useQuery<ScenarioStatsResponse>({
        queryKey: ['scenarioStats', classId, params],
        queryFn: async () => {
            const response = await getScenarioStats(classId, params);
            return response as ScenarioStatsResponse;
        },
        ...options,
    });
}
